import { connect } from "react-redux";
import ViewReportPmSoftwareSites from "./View";
import { bindActionCreators } from "redux";
import { pmSoftwareViewReport, pmSoftwarePostMail,pmSoftwareReportRejected,pmSiteReportDownload, pmSoftwareReportApprove } from "services/redux/maintenance/pmSities/action";
import {
    getPocBySiteId,
} from "services/redux/installation/siteInspection/action";

const mapStateToProps = (state) => ({
    pmSoftwareReportDetails: state.pmSitiesReducer.pmSoftwareReportDetails,
    pocListBySiteId: state.siteInspectionReducer.pocListBySiteId,

});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            pmSoftwareViewReport,
            getPocBySiteId,
            pmSoftwarePostMail,
            pmSiteReportDownload,
            pmSoftwareReportRejected,
            pmSoftwareReportApprove
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ViewReportPmSoftwareSites);
